import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import Tracking from '../tracking';

type LinksProps = {
    title: string;
    url: string;
};

type OverflowmenuProps = {
    links?: LinksProps[];
    callback: () => void;
    blockItem?: Array<string>;
    tracking: Tracking;
    url: string;
    showHistoryLink?: boolean;
};

const Overflowmenu: React.FC<OverflowmenuProps> = (props) => {
    const {
        callback,
        blockItem,
        tracking,
        links,
        url,
        showHistoryLink = false,
    } = props;
    const [isActive, setIsActive] = useState(false);
    const displaySettings = useCallback(() => {
        try {
            fetch(`${url}/tracking/overflowclick`);
        } catch (error) {}
        setIsActive(!isActive);
    }, [isActive, url]);

    const blockCurrItem = useCallback(
        (e) => {
            if (!blockItem) return;
            blockItem.forEach((blockUrl) => {
                tracking.trackWithUrl(blockUrl);
            });
        },
        [blockItem, tracking]
    );

    const listStyle = {
        listStyle: 'none',
    };

    return (
        <div className="recommendation-overflow-menu u-position-relative pb-4">
            <button
                className="recommendations-overflow-button button button--pill button--small u-position-absolute u-right icon icon--overflow-menu-horizontal"
                onClick={(e) => {
                    e.stopPropagation();
                    displaySettings();
                }}
                aria-expanded={isActive ? 'true' : 'false'}
                aria-label="Meny for denne anbefalingen"
            ></button>
            <div
                className={classNames(
                    'hidden recommandations-custom-options-box bg-white m-16 mt-0',
                    { isActive: isActive }
                )}
            >
                <ul style={listStyle} className="p-0 m-0">
                    <li>
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                callback();
                                blockCurrItem(e);
                                displaySettings();
                            }}
                            className="text-14 p-8 block"
                        >
                            Fjern denne anbefalingen
                        </a>
                    </li>
                    {showHistoryLink ? (
                        <li>
                            <a
                                onClick={() => displaySettings()}
                                href="/anbefalinger/historikk"
                                className="text-14 p-8 block"
                            >
                                Hvorfor anbefaler vi denne?
                            </a>
                        </li>
                    ) : (
                        ''
                    )}
                    {links?.map((item, i) => (
                        <li key={i}>
                            <a href={item.url} className="text-14 p-8 block">
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};
export default Overflowmenu;
